import { SubAPI } from "./SubAPI";
export class UserPreferences extends SubAPI {
    list(input) { return this.fetcher.get("/api/user-preferences", input); }
    upsert(input) { return this.fetcher.post("/api/user-preference", input); }
}
